<template>
    <div class="content registerAgreement" :class="!isMobile ? 'web' : ''" style="height: calc(100% - 44px)" >
        <div id="commitment-box">
            <p id="title">
                {{title}}
            </p>
            <div class="t-bar"></div>

            <div id="txtBox" v-html="content">

            </div>

            <div class="t-bar"></div>
            <div class="item">
                <div class="btn-group" v-if="isMobile">
                    <button @click="close()" class="border-btn register-btn"
                            style="width: 100%;border-radius: 4px;color: #101010">确定
                    </button>
                </div>
                <div class="btn-group" v-else style="text-align: center">
                    <el-button type="primary" style="width: 50%" @click="close()">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['title', 'content'],
  computed: {
    isMobile () {
      return this.$root.isMobile
    }
  },
  methods: {
    close () {
      this.$emit('closeNotice')
    }
  }
}
</script>

<style lang="less" scoped>
    .registerAgreement {
        &.web {
            height: auto !important;
            position: fixed;
            top: 55px;
            left: 0px;
            right: 0px;
            z-index: 2147483647;
            padding-top: 74px;
            background-color: white;
            bottom: 0;
            overflow: auto;
            #commitment-box {
                max-width: 850px;
                margin: 0 auto;
                height: auto;
                white-space: initial;
            }
        }
        .btn-group {
            margin-top: 30px;
            white-space: nowrap;
            text-align: justify;
            .bg-btn.register-btn {
                color: #c39768;
                &::first-line {
                    color: white !important;
                }
            }
            .border-btn.register-btn {
                color: #c39768;
            }
            .register-btn {
                width: 48%;
                line-height: 36px;
                border-radius: 18px;
            }
        }
        #txtBox p {
            margin-bottom: 0;
            line-height: 2;
            &.index {
                text-indent: 0;
            }
            &.chapter-title {
                text-align: center;
                font-size: 15px;
            }
        }
        #txtBox {
            text-align: left;
            font-size: 14px;
            color: #bb8d49;
            line-height: 25px;
            text-indent: 2em;
            margin-bottom: 30px;
            margin-top: 30px;
        }
        .t-bar {
            width: 60px;
            margin: 0 auto;
            border-bottom: solid 1px #f1e1c9;
        }
        #commitment-box {
            position: relative;
            height: 100%;
            overflow: auto;
            margin-bottom: 65px;
            border: none;
            background-color: #fff;
            text-align: center;
            padding: 25px 12px;
        }
        #commitment-title {
            font-size: 18px;
            font-weight: bold;
            line-height: 55px;
            padding-top: 25px;
            margin-top: 0;
            margin-bottom: 0;
            border-bottom: solid 1px #ccc;
            color: #666;
        }
        #title {
            font-size: 25px;
            color: #bb8d49;
            font-weight: bold;
            margin-top: 0;
            margin-bottom: 25px;
        }
    }
</style>
